import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetSubmissionTypesAsync,
  GetSubmissionObjectorTypesAsync,
  ISubmissionsGridFilterValueList,
} from "../../api/ISubmission";
import { RootState } from "../store";

export interface ISubmissionGridState {
  fetchStatus: string;
  submissionTypes?: ISubmissionsGridFilterValueList;
  submissionObjectorTypes?: ISubmissionsGridFilterValueList;
}

const initialState: ISubmissionGridState = {
  fetchStatus: "Loading...",
  submissionTypes: undefined,
  submissionObjectorTypes: undefined,
};

export const loadSubmissionOptionsAsync = createAsyncThunk(
  "submission/loadOptions",
  async () => {
    const recordTypes = await GetSubmissionTypesAsync();
    const recordObjectorTypes = await GetSubmissionObjectorTypesAsync();
    // The value we return becomes the `fulfilled` action payload
    return {
      submissionTypes: recordTypes,
      submissionObjectorTypes: recordObjectorTypes,
    };
  }
);

export const submissionOptionsSlice = createSlice({
  name: "submissionOptions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadSubmissionOptionsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadSubmissionOptionsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.submissionTypes = action.payload.submissionTypes;
        state.submissionObjectorTypes = action.payload.submissionObjectorTypes;
      });
  },
});

export const selectSubmissionOptions = (state: RootState) =>
  state.submissionOptions;

export default submissionOptionsSlice.reducer;
